import { BaseApi } from '@/main/baseApi';

import { DMS_MODULE, NAME, DokladNaplnFakturaci } from './constants';

function getController(filter: { PovId?: number, ZakazkaId?: number, povId?: number, zakazkaId?: number, dokladId?: number, dokladovId?: number }) {
	if (filter.dokladovId || filter.PovId || filter.povId) return 'Ov';
	if (filter.dokladId || filter.ZakazkaId || filter.zakazkaId) return 'Servis';
	throw Error(`Controler for facturace not found: ${JSON.stringify(filter)}`);
}
class FakturaceProvider extends BaseApi {
	tvorbaFaktury(fakturaceDto: Object, isNahled: boolean = true) {
		const controlerName = getController(fakturaceDto);
		return this.postBlobs(`/${DMS_MODULE}/${controlerName}/TvorbaFaktury?nahled=${isNahled}`, fakturaceDto);
	}

	servisDefault(filter: Object) {
		const controlerName = getController(filter);
		return this.post(`/${DMS_MODULE}/${controlerName}`, filter);
	}

	async pripravFakturaci(dokladNaplnFakturaci: DokladNaplnFakturaci, zakazkaDto: {}) {
		return this.post(`/${DMS_MODULE}/Servis/PripravFakturaci/?dokladNaplnFakturaci=${dokladNaplnFakturaci}`, zakazkaDto);
	}

	tvorbaFakturyPrima(filter: {}) {
		const controlerName = getController(filter);
		return this.fetchPdf(`/${DMS_MODULE}/${controlerName}/TvorbaFakturyPrima`, filter);
	}

	tvorbaDobropisuPrima(filter: {}) {
		const controlerName = getController(filter);
		return this.fetchPdf(`/${DMS_MODULE}/${controlerName}/TvorbaDobropisuPrima`, filter);
	}

	tvorbaKopie(fakturaceDto: { dokladId?: number, dokladovId?: number }, nahled = true) {
		const controlerName = getController(fakturaceDto);
		const doklad3Id = (controlerName === 'Ov') ? fakturaceDto.dokladovId! : fakturaceDto.dokladId!;
		return this.fetchPdf(`/${DMS_MODULE}/${controlerName}/TvorbaKopie`, { doklad3Id, nahled });
	}

	getTaxInvoiceReport(fakturaceDto: { dokladId?: number, dokladovId?: number }, nahled = true) {
		const controlerName = getController(fakturaceDto);
		const doklad3Id = (controlerName === 'Ov') ? fakturaceDto.dokladovId! : fakturaceDto.dokladId!;
		return this.fetchPdf(`/${DMS_MODULE}/${controlerName}/GetInvoiceCopyReport`, { doklad3Id, nahled });
	}

	partSalesQuoteReport(fakturaceDto: Object, isNahled: boolean = true) {
		const controlerName = getController(fakturaceDto);
		return this.postBlobs(`/${DMS_MODULE}/${controlerName}/PartSalesQuoteReport?nahled=${isNahled}`, fakturaceDto);
	}

	quickEstimateReport(fakturaceDto: Object, isNahled: boolean = true) {
		const controlerName = getController(fakturaceDto);
		return this.postBlobs(`/${DMS_MODULE}/${controlerName}/QuickEstimateReport?nahled=${isNahled}`, fakturaceDto);
	}

	quickEstimateCopyReport(fakturaceDto: { dokladId?: number, dokladovId?: number }, nahled = true) {
		const controlerName = getController(fakturaceDto);
		const doklad3Id = (controlerName === 'Ov') ? fakturaceDto.dokladovId! : fakturaceDto.dokladId!;
		return this.fetchPdf(`/${DMS_MODULE}/${controlerName}/QuickEstimateCopyReport`, { doklad3Id, nahled });
	}

	partSalesCopyReport(fakturaceDto: { dokladId?: number, dokladovId?: number }, nahled = true) {
		const controlerName = getController(fakturaceDto);
		const doklad3Id = (controlerName === 'Ov') ? fakturaceDto.dokladovId! : fakturaceDto.dokladId!;
		return this.fetchPdf(`/${DMS_MODULE}/${controlerName}/PartSalesCopyReport`, { doklad3Id, nahled });
	}

	partSalesCreditMemoReportCopy(fakturaceDto: { dokladId?: number, dokladovId?: number }, nahled = true) {
		const controlerName = getController(fakturaceDto);
		const doklad3Id = (controlerName === 'Ov') ? fakturaceDto.dokladovId! : fakturaceDto.dokladId!;
		return this.fetchPdf(`/${DMS_MODULE}/${controlerName}/PartSalesCreditMemoReportCopy`, { doklad3Id, nahled });
	}

	serviceCreditMemoReportCopy(fakturaceDto: { dokladId?: number, dokladovId?: number }, nahled = true) {
		const controlerName = getController(fakturaceDto);
		const doklad3Id = (controlerName === 'Ov') ? fakturaceDto.dokladovId! : fakturaceDto.dokladId!;
		return this.fetchPdf(`/${DMS_MODULE}/${controlerName}/ServiceCreditMemoReportCopy`, { doklad3Id, nahled });
	}

	getInsuranceBillReport(fakturaceDto: Object, isNahled: boolean = true) {
		const controlerName = getController(fakturaceDto);
		return this.postBlobs(`/${DMS_MODULE}/${controlerName}/InsuranceBillReport?nahled=${isNahled}`, fakturaceDto);
	}	

	getCustomerBillReport(fakturaceDto: Object, isNahled: boolean = true) {
		const controlerName = getController(fakturaceDto);
		return this.postBlobs(`/${DMS_MODULE}/${controlerName}/CustomerBillReport?nahled=${isNahled}`, fakturaceDto);
	}

	getCustomerSalesInvoiceReport(fakturaceDto: Object, isNahled: boolean = true) {
		const controlerName = getController(fakturaceDto);
		return this.postBlobs(`/${DMS_MODULE}/${controlerName}/CustomerSalesInvoiceReport?nahled=${isNahled}`, fakturaceDto);
	}

	getWarrantyInvoiceReport(fakturaceDto: Object, isNahled: boolean = true) {
		const controlerName = getController(fakturaceDto);
		return this.postBlobs(`/${DMS_MODULE}/${controlerName}/WarrantyInvoiceReport?nahled=${isNahled}`, fakturaceDto);
	}

	async validateAndCloseOrder(orderId: number | 0) {
		return this.fetch(`/${DMS_MODULE}/Servis/ValidateAndCloseOrder?orderId=${orderId}`);
	}

	invoiceReport(fakturaceDto: Object, isNahled: boolean = true) {
		const controlerName = getController(fakturaceDto);
		return this.postBlobs(`/${DMS_MODULE}/${controlerName}/InvoiceReport?nahled=${isNahled}`, fakturaceDto);
	}

	internalWorkshopReport(filter: {}) {
		const controlerName = getController(filter);
		return this.fetchPdf(`/${DMS_MODULE}/${controlerName}/InternalWorkshopReport`, filter);
	}

	getCustomerStatisfactionNote(filter:{}) {
		return this.fetchPdf('/Uctenky/Reports/GetCustomerSatisfactionReport', filter);
	}

	markReportAsPrint(zakazkaId :number, reportType: string) {
		return this.post(`/Servis/Zakazka/MarkAsPrint?id=${zakazkaId}&reportType=${reportType}`);
	}

	getCustomerIdentifier(zakaznikId :number) {
		return this.fetch(`/Servis/Zakazka/GetCustomerIdentifier?customerId=${zakaznikId}`);
	}

	isUserGstRegistered(zakaznikId : number) {
		return this.fetch('/Kartoteka/Partner/IsUserGstRegistered', { zakaznikId });
	}

	async eGUISplitIssueInvoice(fakturaceDto: Object) {
		const controlerName = getController(fakturaceDto);
		return this.post(`/${DMS_MODULE}/${controlerName}/EGUI_SplitIssueInvoice`, fakturaceDto);
	}	

	async eGUICancelInvoice(eGUICancelInvoiceRequestDTO: {}) {
		return this.fetch(`/${DMS_MODULE}/Servis/EGUI_CancelInvoice`, eGUICancelInvoiceRequestDTO);
	}

	async eGUIPrintInvoice(eGUIPrintInvoiceRequestDTO: {}) {
		return this.fetch(`/${DMS_MODULE}/Servis/EGUI_PrintInvoice`, eGUIPrintInvoiceRequestDTO);
	}

	async eGUICheckBarcode(eGUICheckBarcodeRequestDTO: {}) {
		return this.fetch(`/${DMS_MODULE}/Servis/EGUI_CheckBarcode`, eGUICheckBarcodeRequestDTO);
	}

	async getCreditNotePopUpStatus(documentId:number) {
		return this.fetch(`/${DMS_MODULE}/Servis/IsCreditNotePopupRequired?documentId=${documentId}`);
	}

	async isCustomerInvoiced(orderId: number, customerId: number | null) {
		return this.fetch(`/${DMS_MODULE}/Servis/IsCustomerInvoiced?orderId=${orderId}&customerId=${customerId}`);
	}
}

export const apiProvider = new FakturaceProvider(DMS_MODULE, NAME);
